<!-- <div class="offer-banner" [ngStyle]="getCurrentOfferStyle()">
  <div class="offer-container">
    <div class="offer-content" [class.flip-out]="isAnimating">
      <span class="offer-label">{{ getCurrentOffer().type | uppercase }}:</span>
      <span class="offer-text">{{ getCurrentOffer().text }}</span>
    </div>
  </div>
</div> -->

<div class="slideshow">

</div>
